import { BlockSaveProps } from "@wordpress/blocks";
import React from "react";
import type { BlockAttributes } from "./block.json";
import { InnerBlocks } from "@wordpress/block-editor";

export default function IconCardSave({
  attributes,
}: BlockSaveProps<BlockAttributes>) {
  return (
    <div>
      <img src={attributes.imageUrl} alt={attributes.title} className="icon" />
      <h4>{attributes.title}</h4>
      <div className="content">{attributes.content}</div>
      <div className="iconcard-footer">
        <InnerBlocks.Content />
      </div>
    </div>
  );
}
